"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
const GUIControllerBase_1 = require("./controllers/GUIControllerBase");
const Web3ControllerBase_1 = require("./controllers/Web3ControllerBase");
class App {
    static get gui() { return App.Inst._guiBase; }
    static get chain() { return App.Inst._chainBase; }
    get gui() { return this._guiBase; }
    get chain() { return this._chainBase; }
    constructor(version) {
        this.version = "0.0.1";
        this._instances = new Map();
        this.version = version;
        console.log(this.version);
        App.Inst = this;
    }
    startAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            this._guiBase = this.getInst(GUIControllerBase_1.GUIControllerBase);
            this._chainBase = this.getInst(Web3ControllerBase_1.Web3ControllerBase);
        });
    }
    awaitTime(timeMS) {
        return new Promise((resolve, reject) => {
            setTimeout(() => resolve(), timeMS);
        });
    }
    getInst(cls) {
        const instance = this._instances.get(cls);
        if (!instance)
            throw new Error(`No instance found for ${cls.name}`);
        return instance;
    }
    addInst(cls, instance) {
        this._instances.set(cls, instance);
    }
}
exports.App = App;
//# sourceMappingURL=App.js.map